(function () {
  function initializeShop(shop) {
    if (shop.dataset.p4ShopInitialized === 'true') return;

    var tabs = Array.prototype.slice.call(shop.querySelectorAll('[data-p4-category]'));
    var panels = Array.prototype.slice.call(shop.querySelectorAll('[data-p4-panel]'));
    var select = shop.querySelector('[data-p4-select]');
    var currentLabels = Array.prototype.slice.call(shop.querySelectorAll('[data-p4-current]'));
    var spaceToggles = Array.prototype.slice.call(shop.querySelectorAll('[data-p4-space-toggle]'));
    var spaceTray = shop.querySelector('[data-p4-space-tray]');
    var spaceItems = shop.querySelector('[data-p4-space-items]');
    var spaceCount = shop.querySelector('[data-p4-space-count]');
    var spaceClear = shop.querySelector('[data-p4-space-clear]');
    var selectedProducts = new Map();

    if (!tabs.length || !panels.length) return;

    function activateCategory(handle, moveFocus) {
      var activeTab = null;
      var activePanel = null;

      tabs.forEach(function (tab) {
        var isActive = tab.dataset.p4Category === handle;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
        if (isActive) activeTab = tab;
      });

      panels.forEach(function (panel) {
        var isActive = panel.dataset.p4Panel === handle;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
        if (isActive) activePanel = panel;
      });

      if (select && select.value !== handle) select.value = handle;
      if (activeTab) {
        var activeName = activeTab.querySelector('span');
        currentLabels.forEach(function (label) {
          label.textContent = activeName ? activeName.textContent.trim() : '';
        });
      }
      if (moveFocus && activeTab) activeTab.focus();

      return activePanel;
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        var panel = activateCategory(tab.dataset.p4Category, false);
        if (panel && window.matchMedia('(max-width: 900px)').matches) {
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (typeof nextIndex !== 'number') return;

        event.preventDefault();
        activateCategory(tabs[nextIndex].dataset.p4Category, true);
      });
    });

    if (select) {
      select.addEventListener('change', function () {
        var panel = activateCategory(select.value, false);
        if (panel && window.matchMedia('(max-width: 900px)').matches) {
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    function renderSpace() {
      var count = selectedProducts.size;
      if (spaceCount) spaceCount.textContent = String(count);
      if (spaceTray) spaceTray.hidden = count === 0;

      spaceToggles.forEach(function (toggle) {
        var selected = selectedProducts.has(toggle.dataset.productHandle);
        toggle.setAttribute('aria-pressed', selected ? 'true' : 'false');
        toggle.setAttribute(
          'aria-label',
          (selected ? 'Remove ' : 'Add ') + toggle.dataset.productTitle + (selected ? ' from your space' : ' to your space')
        );
      });

      if (!spaceItems) return;
      spaceItems.replaceChildren();

      selectedProducts.forEach(function (title, handle) {
        var chip = document.createElement('button');
        var remove = document.createElement('span');
        chip.className = 'p4-shop__space-chip';
        chip.type = 'button';
        chip.dataset.productHandle = handle;
        chip.textContent = title;
        remove.textContent = '×';
        remove.setAttribute('aria-hidden', 'true');
        chip.appendChild(remove);
        chip.setAttribute('aria-label', 'Remove ' + title + ' from your space');
        chip.addEventListener('click', function () {
          selectedProducts.delete(handle);
          renderSpace();
        });
        spaceItems.appendChild(chip);
      });
    }

    spaceToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var handle = toggle.dataset.productHandle;
        if (selectedProducts.has(handle)) {
          selectedProducts.delete(handle);
        } else {
          selectedProducts.set(handle, toggle.dataset.productTitle);
        }
        renderSpace();
      });
    });

    if (spaceClear) {
      spaceClear.addEventListener('click', function () {
        selectedProducts.clear();
        renderSpace();
      });
    }

    shop.dataset.p4ShopInitialized = 'true';
  }

  function initializeAllShops(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-p4-shop]')) initializeShop(scope);
    scope.querySelectorAll('[data-p4-shop]').forEach(initializeShop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAllShops(document);
    });
  } else {
    initializeAllShops(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAllShops(event.target);
  });
})();
